import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { Label, InputGroup, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import moment from "moment";
import { Redirect, useHistory, useParams } from "react-router-dom";
import { UserConsumer } from "../../../../UserContext";
import { CalendarHolidays_API } from "../CalendarHolidays_API";
import FormStatus from "../../../../components/FormStatus";
import { AlertPopups } from "../../../../components/AlertPopups";
import { Routes } from "../../../../configurations/config";
import { APIDateFormat } from "../../../Dashboard/DashboardVariables";

const AddNewHoliday = () => {
	let history = useHistory();
	let token = null;
	const { id } = useParams();
	const startDatepickerRef = useRef(null);
	const endDatepickerRef = useRef(null);
	const [flag, setFlag] = useState(true);
	const [duration, setDuration] = useState("");
	const [description, setDescription] = useState("");
	const [formFields, setFormFields] = useState({
		startDate: "",
		endDate: "",
		duration: duration,
		description: description,
	});
	const handleChange = (e) => {
		setFormFields({ ...formFields, ["description"]: e.target.value });
		setDescription(e.target.value);
	};
	const startdatehandleChange = (date) => {
		setFormFields({ ...formFields, ["startDate"]: date });
	};
	const createNewHoliday = (e) => {
		e.preventDefault();
		let body = {
			startDate: moment(formFields.startDate).format(
				"YYYY-MM-DD HH:mm:ss"
			),
			endDate: moment(formFields.endDate).format("YYYY-MM-DD HH:mm:ss"),
			description: formFields.description,
			duration: formFields.duration,
		};
		formFields.startDate
			? axios
					.post(
						`${CalendarHolidays_API.CreateCalendarHoliday}`,
						body,
						{
							headers: { Authorization: `Bearer ${token}` },
						}
					)
					.then(({ status }) => {
						if (status === 200) {
							AlertPopups.successAlert.fire({
								text: "Public Holiday Created Successfully",
							});
							history.push(Routes.AdminCalendarHolidays);
						}
					})
					.catch((err) => {
						if (err.response) {
							if (formFields.endDate === "") {
								AlertPopups.ErrorAlert.fire({
									text: "Please Enter End Date",
								});
							} else {
								AlertPopups.ErrorAlert.fire({
									text: `${err.response.data.message}`,
								});
							}
						}
					})
			: AlertPopups.ErrorAlert.fire({
					text: "Please Enter Start Date",
			  });
	};

	useEffect(() => {
		//call when page is loaded
		if (id) {
			axios
				.get(
					`${CalendarHolidays_API.GetCalendarHolidaysbyPagination}/${id}`,
					{
						headers: { Authorization: `Bearer ${token}` },
					}
				)
				.then(({ data }) => {
					setFormFields({
						startDate: new Date(data.startDate),
						endDate: new Date(data.endDate),
						duration: data.duration,
						description: data.description,
					});
					setFlag(true);
				});
		}
	}, []);

	useEffect(() => {
		//call when end date is changed
		getLeaveDuration();
	}, [formFields.endDate, formFields.endDate]);

	const getLeaveDuration = () => {
		if (formFields.startDate > formFields.endDate) {
			AlertPopups.ErrorAlert.fire({
				text: "Start Date is greater then End Date",
			});
			setDuration("");
		}
		const header = { Authorization: `Bearer ${token}` };
		{
			!flag &&
				axios
					.get(
						`${
							CalendarHolidays_API.CalculateCalendarHoliday
						}?StartDate=${moment(formFields.startDate).format(
							APIDateFormat
						)}&endDate=${moment(formFields.endDate).format(
							APIDateFormat
						)}`,
						{
							headers: header,
						}
					)
					.then(({ data }) => {
						if (formFields.startDate > formFields.endDate) {
							AlertPopups.ErrorAlert.fire({
								text: "Start Date is greater the End Date",
							});
							setDuration("");
						} else {
							setFormFields({
								...formFields,
								["duration"]: data.duration,
							});
						}
					});
		}
	};
	const handleReset = (e) => {
		//function to handle reset form
		e.preventDefault();
		setFormFields({
			startDate: "",
			endDate: "",
			duration: "",
			description: "",
		});
	};

	const endDateHandleChange = (date) => {
		setFormFields({ ...formFields, ["endDate"]: date });
		setFlag(false);
	};

	const updatePublicHoliday = () => {
		const body = {
			startDate: new Date(formFields.startDate),
			endDate: new Date(formFields.endDate),
			duration: formFields.duration,
			description: formFields.description,
		};
		axios
			.put(
				`${CalendarHolidays_API.GetCalendarHolidaysbyPagination}/${id}`,
				body,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then(({ data }) => {
				AlertPopups.successAlert.fire({
					text: "Updated",
				});
				history.push(Routes.AdminCalendarHolidays);
			});
	};

	const openStartDatepicker = () => {
		const datepickerElement = startDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	const openEndDatepicker = () => {
		const datepickerElement = endDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return userDetails.empRole.includes("3") ? ( //Authorization
					<>
						{/*Form Status*/}
						<FormStatus
							title="Create a new  Holiday"
							className="newHoliday"
							onClick={() => {
								history.push(Routes.AdminCalendarHolidays);
							}}
							navigateBack={true}
						/>
						{/*Form Container*/}
						<Form className="leave-form">
							<Label className="form-title" sm={12}>
								Add New Calendar Holidays
							</Label>
							<Form.Group as={Row} className="s-date">
								<Form.Label column lg={2} md={3} sm={3} xs={3}>
									Start date
								</Form.Label>
								<Col lg={5} md={5} sm={3} xs={4}>
									<InputGroup className="datepicker-wrapper">
										<DatePicker
											showYearDropdown
											showMonthDropdown
											dateFormatCalendar=" " //for title
											className="custom-container"
											dateFormat="dd/MM/yyyy"
											selected={formFields.startDate}
											onChange={startdatehandleChange}
											autoComplete="off"
											onChangeRaw={(e) => {
												e.preventDefault();
											}}
											ref={startDatepickerRef}
										/>
										<FontAwesomeIcon
											icon={faCalendarAlt}
											className="calender-icon"
											color="keppel"
											onClick={() =>
												openStartDatepicker()
											}
										/>
									</InputGroup>
								</Col>
								<Form.Label>To</Form.Label>
								<Col>
									<InputGroup className="datepicker-wrapper">
										<DatePicker
											showYearDropdown
											showMonthDropdown
											dateFormatCalendar=" " //for title
											className="custom-container"
											dateFormat="dd/MM/yyyy"
											onChange={endDateHandleChange}
											selected={formFields.endDate}
											minDate={formFields.startDate}
											ref={endDatepickerRef}
										/>
										<FontAwesomeIcon
											icon={faCalendarAlt}
											className="calender-icon"
											color="keppel"
											onClick={() => openEndDatepicker()}
										/>
									</InputGroup>
								</Col>
							</Form.Group>
							<Form.Group
								as={Row}
								className="leave-duration"
								controlId="formPlaintextPassword"
							>
								<Form.Label column lg={2}>
									Duration
								</Form.Label>
								<Col lg={10}>
									<Form.Control
										className="holidayDuration"
										value={formFields.duration}
									/>
								</Col>
							</Form.Group>
							<Form.Group
								as={Row}
								row={2}
								className="comments"
								controlId="formPlaintextPassword"
							>
								<Form.Label column lg={2}>
									Description
								</Form.Label>
								<Col lg={10}>
									<Form.Control
										as="textarea"
										rows={3}
										onChange={handleChange}
										type="text"
										className="holidayDescription"
										value={formFields.description}
										required={true}
										maxLength={200}
									/>
								</Col>
							</Form.Group>

							{/*Buttons Container*/}
							<div className="btns">
								{!id ? (
									<>
										<Button
											className="submit-btn leftBtn"
											onClick={createNewHoliday}
										>
											Submit
										</Button>
										<Button
											className="reset-btn"
											onClick={handleReset}
										>
											Reset
										</Button>
									</>
								) : (
									<Button
										className="submit-btn"
										onClick={() => updatePublicHoliday()}
									>
										Update
									</Button>
								)}
							</div>
							{/*End of Buttons Container*/}
						</Form>
					</>
				) : (
					<Redirect to="/MyDashboard" /> //redirect to unauthorized users
				);
			}}
		</UserConsumer>
	);
};
export default AddNewHoliday;
